import { createSlice } from "@reduxjs/toolkit";

import { STATUS_ALLOWED_ACTIONS } from "../utils/constants";

const proposalManagerSlice = createSlice({
  name: "proposalManager",
  initialState: {
    gettingProposalsData: true,
    refreshingProposalsData: false,
    gettingRelatedDefendantsContacts: null,
    gettingAssociatedDefendantsContacts: null,
    proposalsData: null,
    taskData: null,
    quantumAssessmentData: null,
    relatedProjectsData: null,
    relatedDefendantsContacts: null,
    associatedProjectsData: null,
    associatedDefendantsContacts: null,
    teamData: null,
    teamMembers: null,
    selectedProposalRecipients: [],
    updatingNegotiatingByCM: false,
    negotiatingByCM: null,
    buttonProps: {
      variant: "contained",
      size: "small",
      sx: { minWidth: "100%" },
      allowedActions: null,
    },
    globalProjectData: {
      isGlobalProject: false,
      isLeadProject: true,
      leadProject: null,
    },
    dialogMessage: "",
    negotiateItemData: null,
  },
  reducers: {
    setGettingProposalsData(state, action) {
      state.gettingProposalsData = action.payload;
    },

    setRefreshingProposalsData(state, action) {
      state.refreshingProposalsData = action.payload;
    },

    setGettingRelatedDefendantsContacts(state, action) {
      state.gettingRelatedDefendantsContacts = action.payload;
    },

    setGettingAssociatedDefendantsContacts(state, action) {
      state.gettingAssociatedDefendantsContacts = action.payload;
    },

    setProposalsData(state, action) {
      state.proposalsData = action.payload;
    },

    setTaskData(state, action) {
      state.taskData = action.payload;
    },

    setQuantumAssessmentData(state, action) {
      state.quantumAssessmentData = action.payload;

      const proposalStatus = action.payload?.quantum?.proposalStatus;
      state.buttonProps.allowedActions = STATUS_ALLOWED_ACTIONS[proposalStatus];
    },

    setRelatedProjectsData(state, action) {
      state.relatedProjectsData = action.payload;
    },

    setRelatedDefendantsContacts(state, action) {
      state.relatedDefendantsContacts = action.payload;
    },

    setAssociatedProjectsData(state, action) {
      state.associatedProjectsData = action.payload;
    },

    setAssociatedDefendantsContacts(state, action) {
      state.associatedDefendantsContacts = action.payload;
    },

    setTeamData(state, action) {
      state.teamData = action.payload;
    },

    setTeamMembers(state, action) {
      state.teamMembers = action.payload;
    },

    setSelectedProposalRecipients(state, action) {
      state.selectedProposalRecipients = action.payload;
    },

    setNegotiatingByCM(state, action) {
      state.updatingNegotiatingByCM = false;
      state.negotiatingByCM = action.payload;
    },

    setUpdatingNegotiatingByCM(state, action) {
      state.updatingNegotiatingByCM = action.payload;
    },

    setGlobalProjectData(state, action) {
      state.globalProjectData = action.payload;
    },

    setDialogMessage(state, action) {
      state.dialogMessage = action.payload;
    },

    setNegotiateItemData(state, action) {
      state.negotiateItemData = action.payload;
    },
  },
});

export const proposalManagerActions = proposalManagerSlice.actions;

export default proposalManagerSlice.reducer;
